<form *ngIf="productCode"
      [formGroup]="addToCartForm"
      (submit)="addToCart()"
      class="mb-add-to-cart-form"
      data-cy="mb-add-to-cart-form">
  <button *ngIf="!hasPriceOnRequest"
          type="submit"
          class="btn btn-sm btn-primary mr-1 mb-1 mt-md-2 mt-lg-0 mb-product-line-buttons add-to-cart"
          data-cy="mb-product-line-add-to-cart">
    <img src="../../../../assets/icons/svg/icon_cart_white.svg"
         title="Cart"
         alt="Cart icon"
         aria-label="Cart icon"
         data-cy="mb-cart-icon"/>
  </button>
  <button *ngIf="hasPriceOnRequest"
          type="submit"
          class="btn btn-sm btn-primary mr-1 mb-1 mt-md-2 mt-lg-0 mb-product-line-buttons request-price font-weight-bolder"
          [ngClass]="{'mb-facets-expanded' : facetsExpanded$ | async}"
          data-cy="mb-product-line-request-price"
          [innerHTML]="'mbcommon.requestPrice' | mbTranslate">
  </button>
</form>
